import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';

import { AppState } from '../../../store';
import config from '../../../config';

import EmailConfig from '../screens/config';
import NotFound from '../../not-found';

const Routes: React.FC = () => {
  const authType: string = useSelector((state: AppState) => state.Authorization.authType);
  const publicUrl = process.env.PUBLIC_URL;

  if (authType) {
    return (
      <>
        <Route path={`${publicUrl}/email/config`} component={authType === config.userTypeAdmin ? EmailConfig : NotFound } />
      </>
    )
  } else {
    return null;
  }
}

export default Routes;